import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export const UserStoreModel = {
  email: '',
  password: '',
  type: '',
  isActive: true,
  color: '#000000'
};

export default {
  namespaced: true,
  state: {
    user: { ...UserStoreModel },
    users: [],
  },
  mutations: {
    updateUser(state, user) {
      state.user = user;
    },
    updateUsers(state, users) {
      state.users = users;
    },
    addUser(state, user) {
      state.users.push(user);
    },
    putUser(state, user) {
      state.users = state.users.map((value) => (user.id === value.id ? user : value));
    },
    deleteAction(state, id) {
      state.users = state.users.filter((user) => user.id !== id);
    },
  },
  actions: {

    async getUser({ commit }, id) {
      axiosInstance.get(urlsAPI.usersURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateUser', response.data);
          }
        })
        .catch(handlerError);
    },

    async getUsers({ commit }) {
      axiosInstance.get(urlsAPI.usersURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateUsers', response.data);
          }
        })
        .catch(handlerError);
    },

    async createUser({ commit }, body) {
      return axiosInstance.post(urlsAPI.usersURL, body)
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          commit('addUser', response.data);
          return response.data;
        })
        .catch(handlerError);
    },

    async updateUser({ commit }, { id, body }) {
      axiosInstance.put(urlsAPI.usersURL + id, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('putUser', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, id) {
      axiosInstance.delete(urlsAPI.usersURL + id)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', id);
          }
        })
        .catch(handlerError);
    },

  },
};
